
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHydraulic12On as ObiHydraulic12OnElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-hydraulic-12-on.js';
 
 
 

 
 export const ObiHydraulic12On = createComponent({
   react: React,
   tagName: 'obi-hydraulic-12-on',
   elementClass: ObiHydraulic12OnElement,
   events: {
     
   }
  });
 
 